import { render, staticRenderFns } from "./le2Customer.vue?vue&type=template&id=1861f7c4&"
import script from "./le2Customer.vue?vue&type=script&lang=js&"
export * from "./le2Customer.vue?vue&type=script&lang=js&"
import style0 from "./le2Customer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports